import React from 'react';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { Button, Text, TextTypography, ThreeDotsLoader } from '@wix/wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { classes } from './ErrorState.st.css';

export interface ErrorStateProps {
  onRetry: () => void;
  isLoading?: boolean;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry, isLoading }) => {
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper} data-hook={VIEWER_HOOKS.ERROR_STATE}>
      <Text className={classes.title} typography={TextTypography.smallTitle}>
        {t('blocks.plan-list.error-state.title')}
      </Text>
      <Text
        className={classes.subtitle}
        typography={TextTypography.runningText}
        data-hook={VIEWER_HOOKS.ERROR_STATE_SUBTITLE}
      >
        {t('blocks.plan-list.error-state.subtitle')}
      </Text>
      <div>
        <Button
          data-hook={VIEWER_HOOKS.ERROR_STATE_BUTTON}
          onClick={onRetry}
          disabled={isLoading}
          upgrade
          className={classes.button}
        >
          {isLoading ? <ThreeDotsLoader className={classes.loader} /> : t('blocks.plan-list.error-state.button-label')}
        </Button>
      </div>
    </div>
  );
};
